<template>
    <div class="control_bottom">
        <div class="control_time">
            <div class="control_time_box">
                <div class="m-timeline-wrap" ref="control_time_box">
                    <div
                        class="np"
                        :style="{
                            left: moveDistanceLeft + 'px',
                            right: Math.abs(initRight - moveDistanceRight) + 'px',
                        }"
                    ></div>

                    <div
                        class="m-time-dot"
                        ref="kkk"
                        :style="{ width: openScroll ? `${100 + (curYear - 2021 - 2) * 50}%` : '100%' }"
                    >
                        <div class="m-dot-box" v-for="(item, index) in curYear - 2021" :key="index">
                            <p class="u-year">{{ 2021 + index }}</p>
                            <div class="m-dot">
                                <div class="u-dot" ref="a"></div>
                            </div>
                            <div class="m-dot-box-k">
                                <div class="k" v-for="(i, k) in 12" :key="k">
                                    <div
                                        class="k_active_l"
                                        :style="{
                                            background: moveDistanceLeft <= 0 ? '#49f0fd' : '',
                                        }"
                                    ></div>
                                    <div
                                        class="k_active_r"
                                        :style="{
                                            background:
                                                (showSelectYear.includes(item) &&
                                                    showSelectMonthLeft.includes(i)) ||
                                                (showSelectYear.includes(item - 1) &&
                                                    showSelectMonthRight.includes(i)) ||
                                                showSelectYear1.includes(item - 1) ||
                                                (item === selectTimeShow.yearLeft - 2020 &&
                                                    showSelectMonthLeft.includes(i) &&
                                                    item === selectTimeShow.yearRight - 2020 &&
                                                    showSelectMonthRight.includes(i))
                                                    ? '#49f0fd'
                                                    : '',
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="m-dot-box m-dot-box1">
                            <p class="u-year">{{ curYear }}</p>
                        </div>
                    </div>
                </div>

                <Slides
                    class="slides"
                    :selectWidth="selectWidth"
                    @changeSelectTime="changeSelectTime"
                    :scrollX="scrollX"
                    :reset="reset"
                    :oneYearDistance="oneYearDistance"
                    :setSelectTime="setSelectTime"
                    :getMoveFn="getMoveFn"
                ></Slides>
            </div>
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll';
import Slides from './slide.vue';

export default {
    inject: ['selectTime'],
    components: {
        Slides,
    },
    props: {
        reset: {
            default: false,
            type: Boolean,
        },
        typeNum: [Number, String],
        flyType: Number,
        openScroll: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            active: this.activeYear,
            scroll: null,
            scrollX: 0,
            selectWidth: 0,
            curYear: new Date().getFullYear() + 1,
            oneYearDistance: 0, // 一年的12个格子宽度
            selectTimeShow: {
                yearLeft: new Date().getFullYear(),
                yearRight: new Date().getFullYear(),
                monthLeft: new Date().getMonth() + 1,
                monthRight: new Date().getDay() + 1,
            },
            moveDistanceLeft: '',
            moveDistanceRight: '',
            initRight: '',
        };
    },
    computed: {
        showSelectMonthLeft() {
            let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            arr = arr.splice(this.selectTimeShow.monthLeft - 1);
            return arr;
        },
        showSelectMonthRight() {
            let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            arr.splice(this.selectTimeShow.monthRight - 1); // 1控制右边月份
            return arr;
        },
        showSelectMonthRight_active() {
            let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            arr.splice(this.selectTimeShow.monthRight + 1);
            return arr;
        },
        showSelectYear() {
            // 1开始为2021
            let arr = Array.from({ length: this.curYear - 2021 }, (item, index) => index + 1);
            let ge = this.selectTimeShow.yearRight - this.selectTimeShow.yearLeft;
            arr = arr.splice(this.selectTimeShow.yearLeft - 2021, ge);
            return arr;
        },
        showSelectYear1() {
            let arr = [...this.showSelectYear];
            arr.pop();
            return arr;
        },
    },
    watch: {

        reset() {
            this.getWidth();
            if (this.openScroll) {
                this.initScroll();
                this.scrollX += 0.000000001;
            }
        },
        selectTime: {
            deep: true,
            handler(newVal) {
                this.openScroll && this.initScroll();
            },
        },
        typeNum: {
            handler(newVal) {
                this.getWidth();
            },
            immediate: true,
            deep: true,
        },

    },
    mounted() {
        setTimeout(() => {
            this.getWidth();
            this.openScroll && this.initScroll();
        }, 10);
        window.addEventListener('resize', (e) => {
            setTimeout(() => {
                this.getWidth();
                this.openScroll && this.initScroll();
            }, 10);
            this.scrollX += 0.000000001;
        });
    },
    methods: {
        changeSelectTime(type, val) {
            this.$emit('changeSelectTime', type, val);
        },
        // 用来设置滑动下面的条子
        getMoveFn(val1, val2, initRight) {
            this.moveDistanceLeft = val1;
            this.moveDistanceRight = val2;
            if (initRight) {
                this.initRight = initRight;
            }
        },
        getWidth() {
            this.selectWidth = 0;
            this.selectWidth = this.$refs.kkk && this.$refs.kkk.offsetWidth / (this.curYear - 2021) / 12;
        },
        initScroll() {
            this.oneYearDistance = this.selectWidth * 12;
            this.scrollX = this.oneYearDistance * (this.selectTimeShow.yearLeft - 2022);
            if (this.selectTimeShow.yearLeft - this.selectTimeShow.yearRight < 0) {
                this.scrollX = this.oneYearDistance * (this.selectTimeShow.yearLeft - 2021);
            }
            if (this.oneYearDistance) {
                if (!this.scrollX) this.scrollX = -500;
                console.log(this.$refs.control_time_box);
                this.scroll = new BScroll(this.$refs.control_time_box, {
                    scrollX: true,
                    startX: -this.scrollX, // 开始的Y轴位置
                    // startX: -420 * 1, // 开始的Y轴位置
                });
                console.log(this.scrollX);
                this.scroll.on('scrollEnd', (pos) => {
                    this.scrollX = Math.abs(pos.x);
                });
            }
        },
        setSelectTime(yearLeft, yearRight, monthLeft, monthRight) {
            this.selectTimeShow = {
                yearLeft,
                yearRight,
                monthLeft,
                monthRight,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.control_bottom {
    position: absolute;
    // overflow: hidden;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 124px - 124px);
    // width: 1000px;
    height: 66px;
    background: linear-gradient(
        270deg,
        rgba(12, 42, 88, 0) 0%,
        rgba(12, 42, 88, 0.71) 16%,
        rgba(9, 60, 139, 0.8) 50%,
        rgba(12, 42, 88, 0.75) 85%,
        rgba(12, 42, 88, 0) 100%
    );
    // background-color: deepskyblue;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid;
    border-image: linear-gradient(
            90deg,
            rgba(73, 240, 253, 0),
            rgba(73, 240, 253, 0.8),
            rgba(73, 240, 253, 0.8),
            rgba(73, 240, 253, 0)
        )
        1 1;
    .control_time {
        // width: 835px;
        width: calc(100% - 162px);
        box-sizing: border-box;
        height: 100%;
        // overflow: hidden;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 5px 0.9vw;
        overflow: hidden;
        // padding-left: 30px;
        // padding-left: 11px;
        // width: calc(100% - 100px - 100px);
        // height: 4px;
        // background: #2E7DF8B3;
        .control_time_box {
            box-sizing: border-box;
            // width: calc(100% - 6px);
            height: 100%;
            // position: absolute;
            // left: 50%;
            // top: 50%;
            // transform: translate(-50%, -50%);
            // background-color: rgba(73, 240, 253, 0.5);
            width: calc(100% - 31px);
            position: absolute;
            left: 50%;
            /* width: 100%; */
            transform: translateX(-50%);
        }
        .m-timeline-wrap {
            width: 95%;
            position: absolute;
            top: 32px;
            height: 3px;
            .np {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 2px;
                background-color: rgb(73, 240, 253);
                top: -2px;
                z-index: 99;
            }
            //   background: #2E7DF8B3;
            .m-time-dot {
                width: 100%;
                display: flex;
                .month {
                    width: 70px;
                    // background-color: pink;
                    height: 1px;
                    display: inline-block;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: -10px;
                        display: inline-block;
                        height: 10px;
                        width: 2px;
                        // background-color: #2E7DF8B3;
                    }
                }
                .end {
                    height: 1px;
                    display: inline-block;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: -10px;
                        display: inline-block;
                        height: 10px;
                        width: 2px;
                        background-color: #2e7df8b3;
                    }
                }
                .m-dot-box1 {
                    width: 2px !important;
                    .k_active {
                        position: absolute;
                        top: -24px;
                        height: 10px;
                        width: 2px;
                        left: -1px;
                        background-color: #2e7df8b3;
                    }
                }

                .m-dot-box {
                    // width: 800px;
                    width: calc(100%);
                    position: relative;
                    cursor: pointer;
                    text-align: center;
                    transform: translateY(calc(-100% + 14px));
                    &:nth-child(1) .k:nth-child(1) .k_active_l {
                        position: absolute;
                        top: -6px;
                        height: 7px;
                        width: 2px;
                        background-color: #2e7df8b3;
                        left: 0;
                    }
                    .m-dot-box-k {
                        width: 100%;
                        font-size: 14px;
                        position: absolute;
                        top: -26px;
                        .month1 {
                            position: absolute;
                            left: -12px;
                            top: 9px;
                            color: #fff;
                            cursor: pointer;
                        }
                        .k_end {
                            &::before {
                                content: '';
                                position: absolute;
                                left: 33px;
                                top: 3px;
                                display: inline-block;
                                height: 10px;
                                width: 2px;
                                background-color: #2e7df8b3;
                            }
                        }
                        .no_k {
                            width: 9.083% !important;
                            .month12 {
                                position: absolute;
                                white-space: nowrap;
                                right: -6%;
                            }
                        }
                        .k {
                            width: 8.333%;
                            background-color: #2e7df8b3;
                            height: 2px;
                            display: inline-block;
                            position: relative;

                            .k_active {
                                position: absolute;
                                top: -8px;
                                height: 10.2px;
                                width: 2px;
                                left: -1px;
                                background-color: #2e7df8b3;
                            }
                            .k_active_r {
                                position: absolute;
                                top: -6px;
                                height: 7px;
                                width: 2px;
                                background-color: #2e7df8b3;
                                right: 0;
                            }

                        }
                    }
                    .u-year {
                        position: absolute;
                        left: -15px;
                        top: -75px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #fff;
                        transform: translateY(70px);
                        transition: all 0.3s ease;
                    }
                    .m-dot {
                        width: 0;
                        height: 0;
                        background: #8dc6f5;
                        transition: all 0.3s ease;
                        .u-dot {
                            width: 0;
                            height: 0;
                            background: #8dc6f5;
                            border-radius: 50%;
                            transition: all 0.3s ease;
                        }
                    }
                }
                .active {
                    .u-year {
                        transform: scale(2) translateY(35px); // 同时设置多个transform属性只需用空格间隔，执行时从后往前执行！
                        color: #2e7df8b3;
                    }
                    .m-dot {
                        transform: scale(3);
                        .u-dot {
                            transform: scale(0.67);
                            background: #2e7df8b3;
                        }
                    }
                }
            }
        }
        .selectTime {
            color: #fff;
            position: absolute;
            display: flex;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 999999999;
            cursor: pointer;
        }
    }
}

.select {
    position: absolute;
    top: 0;

    height: 14px;
    left: 15px;
    right: 30px;
    .select_left,
    .select_right {
        position: absolute;
        width: 10px;
        height: 14px;
        background: #2e7df8;
        cursor: pointer;
    }
    .select_right {
        right: 0;
    }
}
</style>
